import { IReduxState } from 'types/redux';

export const tepHistoryReportSelector = (state: IReduxState) => state.reports.tepHistory;
